export default "__VITE_ASSET__DJbL2BrK__"